export const DEFAULT_MONEY_REACT_NUMBER_FORMAT_PROPS = {
  prefix: 'R$ ',
  thousandSeparator: '.',
  decimalSeparator: ',',
  decimalScale: 2,
  fixedDecimalScale: true,
};
